export enum LiveFeedQuestionStartedTabs {
  COMMENT_TAB = 1,
  TOP_VOTED_TAB = 2,
}
